import { apolloHooks } from '@nxte-nl/apollo-hooks';

import { getBlocksQueue } from '../../../queries/getBlocksQueue.gql';
import {
  TopBlock,
  TopProductsResponse,
} from '../../../types/apiCompoundProduct';

export const getBlocksQueueHooks = {
  useGetBlocksQueueQuery(
    handleResponse: (response: TopProductsResponse<TopBlock> | null) => void,
  ) {
    const [executeRequest, { loading }] = apolloHooks
      .useLazyQuery(getBlocksQueue, { onCompleted: handleResponse });
    return { executeRequest, loading };
  },
};
